module.exports = __webpack_public_path__ + "media/react/components/PatientBox/RentalStatus/assets/icon_tkura_unconfirmed-720e14fad42371fa549cab4e6c222aea.svg";